import request from '@/utils/request'
export const queryPage = '/icps/system/sign/cloudSell/pro/customer/queryPage'
export const saveOrUpdate = '/icps/system/sign/cloudSell/pro/customer/saveOrUpdate'

/*查询合作项目*/
export function queryEngineering(data) {
  return request({
    url: '/icps/system/sign/cloudSell/pro/customer/queryEngineering',
    method: 'post',
    data
  })
}
/*修改合作记录*/
export function updateRecord(data) {
  return request({
    url: '/icps/system/sign/cloudSell/pro/customer/updateRecord',
    method: 'post',
    data
  })
}